import { render, staticRenderFns } from "./ClientAttachmentCard.vue?vue&type=template&id=57b60c94&"
import script from "./ClientAttachmentCard.vue?vue&type=script&lang=ts&"
export * from "./ClientAttachmentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports